const CACHE_NAME = "oculai-cache";
const EXPIRES_HEADER = "expires";
const DEFAULT_EXPIRY = 1000 * 60 * 60 * 24; // 24 hours

const getCache = async (key: string) => {
  const cache = await caches.open(CACHE_NAME);
  const response = await cache.match(key);

  if (!response) {
    return;
  }

  const headers = response.headers;
  const expires = headers.get(EXPIRES_HEADER);
  if (expires && new Date(expires) < new Date()) {
    await cache.delete(key);

    return;
  }

  return response;
};

const setCache = async (key: string, value: unknown, expiry = DEFAULT_EXPIRY) => {
  const cache = await caches.open(CACHE_NAME);
  const expires = new Date(Date.now() + expiry).toUTCString();
  const headers = new Headers();
  headers.set(EXPIRES_HEADER, expires);

  const responseValue = value instanceof Blob ? value : JSON.stringify(value);

  await cache.put(key, new Response(responseValue, { headers }));
};

const deleteCache = async (key: string) => {
  const cache = await caches.open(CACHE_NAME);
  await cache.delete(key);
};

const clearExpiredCache = async () => {
  const cache = await caches.open(CACHE_NAME);
  const keys = await cache.keys();

  for (const request of keys) {
    const response = await cache.match(request);

    if (!response) {
      return;
    }

    const headers = response.headers;
    const expires = headers.get(EXPIRES_HEADER);
    if (expires && new Date(expires) < new Date()) {
      await cache.delete(request);
    }
  }
};

const cachePlugin = {
  install() {
    const hour = 1000 * 60 * 60;
    setInterval(clearExpiredCache, hour);
    clearExpiredCache();
  },
};

export default {
  getCache,
  setCache,
  deleteCache,
  cachePlugin,
};
